import {
  RELATED_PRODUCT_REQUEST,
  RELATED_PRODUCT_RECEIVED,
} from 'redux/actions/related-product';

const initialState = {
  hasError: false,
  data: {},
  loading: true,
};

export default function relatedProduct(state = initialState, action) {
  switch (action.type) {
    case RELATED_PRODUCT_REQUEST:
      return Object.assign({}, state, {
        ...state,
        hasError: false,
        data: {
          ...state.data,
          [action.slug]: {
            loading: true,
          },
        },
      });
    case RELATED_PRODUCT_RECEIVED:
      return Object.assign({}, state, {
        hasError: false,
        data: {
          ...state.data,
          [action.slug]: {
            loading: false,
            ...action.product,
          },
        },
      });
    default:
      return state;
  }
}
